import { MainButton } from "../../atoms";
import { useTranslation } from "react-i18next";
import SendEmailToUser from "./SendEmailToUser";
import { useContext } from "react";
import { BoardContext, SocketContext, TeamContext } from "../../../context";
import { getUrlTokenExtracted } from "../../../context/helpers";
import { useIsAnyUserLoggedOut } from "../../../hooks";
import { IPlayer } from "../../../interfaces";
import { Phase } from "../../../util/enums";
import axios from "axios";

const SideBarPlayersList = () => {
    const { socket } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const [isAnyUserCurrentlyLoggedOut, listOfTheUsersWhoLoggedout] = useIsAnyUserLoggedOut();
    const { sendMessageToTheUser, setSendMessageToTheUser } = useContext(BoardContext);
    const { t } = useTranslation();
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email });
    const spinWheelPlayer = game?.players.find((player: IPlayer) => { return game.gameInfo.currentSpinOwner === player.email });
    const isGamePhaseSlotMachine = game?.phase == Phase.SLOT_MACHINE;
    const isGamePhaseQuestionCard = game?.phase == Phase.QUESTION_CARD
    const isItCelebrationPhase = game?.phase == Phase.SOLUTION_CHOSEN_REWARD || game?.phase == Phase.CONFETTI_CELEBRATION || game?.phase == Phase.SOLUTION_CHOSEN;

    const openMessageBox = (userEmail: string) => {
        setSendMessageToTheUser({ 
            selectedUserEmail: userEmail, 
            isMessageBoxOpen: true 
        })
    }

    const logOutOtherPlayerKickOut = (selectedUserEmail: string) => {
        let payload = {
            matchId: getUrlTokenExtracted(),
            gameId: 1,
            playerEmail: selectedUserEmail
          };
        socket?.emit("kickPlayer",payload);
    }

    const logOutOtherWaitingRoomPlayerKickOut = (selectedUserEmail: string) => {
        let payload = {
            matchId: getUrlTokenExtracted(),
            gameId: 1,
            playerEmail: selectedUserEmail
          };
        socket?.emit("kickNewPlayer",payload);
    }

    const refreshPlayer = (userEmail: string) => {
        socket?.emit("refresh", {email: userEmail});
    }

    const reconnectPlayer = (userEmail: string) => {
        socket?.emit("reconnection", {email: userEmail, matchId: getUrlTokenExtracted()});
    }

    const playJokerInsteadOfAPlayer = (userEmail: string) => {
        socket?.emit("proposeJoker", {email: userEmail,})
    }

    const forceNextPhase = () => {
        axios({
            method: "get",
            url: process.env.REACT_APP_BACKEND_URL + 'api/matches/push-phase/' + getUrlTokenExtracted(),
          })
    }

    const getAllActivePlayers = () : string[] => {
        let listOfEmailsOfAllUsers: string[] = game?.players.map( (player: any, index: any) => {
            if (player?.email)
                return player?.email;
            return "";
        }) || [];
        let filteredListOfEmailsOfAllUsers = listOfEmailsOfAllUsers.filter( (element: any) => !getAllInactivePlayers().includes(element) )
        return filteredListOfEmailsOfAllUsers;
    }

    const listAllActivePlayers = () => {
        
        return getAllActivePlayers().map( (activePlayer: any, index: number) => {
            return(
                <div className="user" key={index}> 
                    <div> {index+1}.<span className="user_email"> {activePlayer} </span> </div>
                    <div className="button_rows"> 
                        {dilemmaOwner?.email != activePlayer && spinWheelPlayer?.email != activePlayer && getAllActivePlayers()?.length > 2 &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("logOutText")} clickHandler={() => logOutOtherPlayerKickOut(activePlayer)} />
                        </div>
                        }
                        {!isGamePhaseSlotMachine &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("playInsteadText")} clickHandler={() => playInsteadJoinByForce()} />
                        </div>
                        }
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("sendAnEmailText")} clickHandler={() => openMessageBox(activePlayer)} />
                        </div>
                        {!isGamePhaseSlotMachine &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("refreshText")} clickHandler={() => refreshPlayer(activePlayer)} />
                        </div>
                        }
                        {isGamePhaseQuestionCard && dilemmaOwner?.email != activePlayer &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("playJokerText")} clickHandler={() => playJokerInsteadOfAPlayer(activePlayer)} />
                        </div>
                        }
                    </div>
                </div>
            )
        })
    }

    const getAllInactivePlayers = () : string[] => {
        let listOfEmailsOfAllUsers: string[] = listOfTheUsersWhoLoggedout.map( (player: IPlayer, index: any) => {
            if (player?.email)
                return player?.email;
            return "";
        }) || [];
        return listOfEmailsOfAllUsers
    }

    const listAllInactivePlayers = () => {
        return getAllInactivePlayers().map( (inactivePlayer: string, index: number) => {
            return(
                <div className="user" key={index}> 
                    <div> {index+1}.<span className="user_email"> {inactivePlayer} </span> </div>
                    <div className="button_rows"> 
                    {dilemmaOwner?.email != inactivePlayer && spinWheelPlayer?.email != inactivePlayer &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("logOutText")} clickHandler={() => logOutOtherPlayerKickOut(inactivePlayer)} />
                        </div>
                    }
                        {!isGamePhaseSlotMachine &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("playInsteadText")} clickHandler={() => playInsteadJoinByForce()} />
                        </div>
                        }
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("sendAnEmailText")} clickHandler={() => openMessageBox(inactivePlayer)} />
                        </div>
                        {!isGamePhaseSlotMachine &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("refreshText")} clickHandler={() => refreshPlayer(inactivePlayer)} />
                        </div>

                        }
                        {isGamePhaseQuestionCard && dilemmaOwner?.email != inactivePlayer &&
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("playJokerText")} clickHandler={() => playJokerInsteadOfAPlayer(inactivePlayer)} />
                        </div>
                        }
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("reconnectText")} clickHandler={() => reconnectPlayer(inactivePlayer)} />
                        </div>
                    </div>
                </div>
            )
        })
    }

    const playInsteadJoinByForce = () => {
        window.open(process.env.REACT_APP_FRONTEND_URL + "force/" + getUrlTokenExtracted());
    }

    const getAllPlayersThatAreInWaitingRoom = () : string[] => {
        const array: any[] = game?.inGameLobby || [];
        let listOfEmailsOfAllUsersFromWaitingRoom: string[] = array.map( (player: any, index: any) => {
            if (player?.email)
                return player?.email;
            return "";
        }) || [];
        return listOfEmailsOfAllUsersFromWaitingRoom
    }

    const listAllPlayersInWaitingRoom = () => {
        return getAllPlayersThatAreInWaitingRoom().map( (playerInWaitingRoom: string, index: number) => {
            return(
                <div className="user" key={index}> 
                    <div> {index+1}.<span className="user_email"> {playerInWaitingRoom} </span> </div>
                    <div className="button_rows"> 
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("logOutText")} clickHandler={() => logOutOtherWaitingRoomPlayerKickOut(playerInWaitingRoom)} />
                        </div>
                        <div className="button_wrapper"> 
                            <MainButton smallText={true} type="small" text={t("sendAnEmailText")} clickHandler={() => openMessageBox(playerInWaitingRoom)} />
                        </div>
                    </div>
                </div>
            )
        })
    }

    const refreshAllUsers = () =>{
        return(
            <div className="button_wrapper"> 
                <MainButton smallText={true} type="big" text={t("refreshAllPlayersText")} clickHandler={() => refreshPlayer("all")} />
            </div>
        ) 
    }

    const goToTheNextPhase = () =>{
        return(
            <div>
                <MainButton smallText={true} type="small" text={t("nextPhaseText")} clickHandler={() => forceNextPhase()} />
            </div>
        ) 
    }
    return (
        <div className="players_list_wrapper">
            <div className="title"> {t("activePlayersText")} </div>
            {listAllActivePlayers()}
            <div className="title"> {t("inactivePlayersText")} </div>
            {listAllInactivePlayers()}
            <div className="title"> {t("WaitingRoomText")} </div>
            {listAllPlayersInWaitingRoom()}
            {sendMessageToTheUser.isMessageBoxOpen && <SendEmailToUser />}
            {!isGamePhaseSlotMachine && <div className="refreshButtonWrapper"> {refreshAllUsers()} </div>}
            {isItCelebrationPhase && <div className="refreshButtonWrapper"> {goToTheNextPhase()} </div>}
            
        </div>
    )
}

export default SideBarPlayersList;